"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _user = require("@/api/crm/user");
var _jsMd = _interopRequireDefault(require("js-md5"));
var _default = exports.default = {
  name: 'PageUserPwdReset',
  data() {
    return {
      form: {
        mobile: this.$store.getters.userInfo.account
      },
      isSending: false,
      canSend: true,
      loading: false
    };
  },
  methods: {
    async onSubmit() {
      try {
        this.loading = true;
        await this.$refs.form.validate();
        await (0, _user.postPwdReset)(_lodash.default.omit({
          ...this.form,
          newPassword: (0, _jsMd.default)(this.form.newPassword)
        }, ['_confirmPassword']));
        this.$confirm({
          title: '操作成功',
          content: '密码已重置，请返回登录',
          parentContext: this,
          onOk: async () => {
            this.$router.replace('/user/login');
          }
        });
      } finally {
        this.loading = false;
      }
    },
    async handleSendBtnClick() {
      try {
        this.isSending = true;
        await new Promise((resolve, reject) => {
          this.$refs.form.validateField(['mobile'], errMsg => {
            errMsg ? reject(errMsg) : resolve();
          });
        });
        const res = await (0, _user.postSmsSend)({
          mobile: this.form.mobile
        });
        _lodash.default.assign(this.form, res);
        this.$message.success('发送成功');
        this.canSend = false;
      } finally {
        this.isSending = false;
      }
    },
    async onCountDownFinish() {
      this.canSend = true;
    }
  }
};